import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: false,
    userInfo: {},
    clientHeight: 0,
  },
  getters: {
    isLogin(state) {
      if (state.token == "") {
        state.token = sessionStorage.getItem('token');
      }
      return (state.token != "")
    },
    getToken(state) {
      if (state.token == "") {
        state.token = sessionStorage.getItem('token');
      }
      return state.token
    },
    getDomain() {
      // 正式
      return "https://mro.tcmtc.com.cn";
      // 测试
      // return "http://mro-new.gdpbb.cn/item?id=";
      // 正式
      // return "http://mro.tcmtc.com.cn/item?id=";
      // return "http://localhost:8080";
    }
  },
  mutations: {
    login(state, token) {
      state.token = token;
      sessionStorage.setItem("token", token);
    },
    logout(state) {
      state.token = "";
      sessionStorage.setItem("token", "");
      sessionStorage.clear();
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
      sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
    },
  },
  actions: {

  }
})
